interface SetCookiesFn {
  (
    value: string,
    options?: { expires?: string; domain?: string; secure?: boolean }
  ): void;
}

const useCookies = (
  cookieName: string
): [string | null, SetCookiesFn, () => void] => {
  const getCookie = (name: string) => {
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    if (match) return match[2];
    return null;
  };

  const setCookie: SetCookiesFn = (value, options = {}) => {
    let cookieString = `${cookieName}=${value}; path=/`;
    if (options.expires) {
      cookieString += `; expires=${options.expires}`;
    }
    if (options.domain) {
      cookieString += `; domain=${options.domain}`;
    }
    if (options.secure) {
      cookieString += '; secure';
    }
    document.cookie = cookieString;
  };

  const removeCookie = (options = {}) => {
    setCookie('', { ...options, expires: 'Thu, 01 Jan 1970 00:00:01 GMT' });
  };

  const cookies = getCookie(cookieName);

  return [cookies, setCookie, removeCookie];
};

export default useCookies;
